import { PL_LOG_GROUPS, logger } from '@/utils';
import { LOG_LEVEL } from '@b2x/shared';
import { initializeStore } from '@seamless/store';
import { SDSProfileConnection } from './sds-connection';

export async function initializeLegacySDSConnection() {
  const store = initializeStore();
  await store.addConnection(new SDSProfileConnection());

  logger('Initialized SDS connection', {
    group: PL_LOG_GROUPS.LEGACY,
    level: LOG_LEVEL.INFO,
  });
}
